import { IconButton } from "@App/Components/common/IconButton/IconButton";
import { InspectionIcon, MiscIcon } from "@App/Components/common/Icons";
import { useTranslation } from "react-i18next";

interface ReportDamageStepProps {
  handleYes: () => void;
  handleNo: () => void;
}

export function ReportDamageStep({ handleYes, handleNo }: ReportDamageStepProps) {
  const { t } = useTranslation();
  return (
    <div className={"grid grid-cols-1 md:grid-cols-2 gap-2 my-4 md:w-fit"}>
      <IconButton
        icon={<MiscIcon />}
        title={t("yes")}
        subtitle={t("reportDamage.yesDescription")}
        onClick={handleYes}
      />
      <IconButton
        icon={<InspectionIcon />}
        title={t("no")}
        subtitle={t("reportDamage.noDescription")}
        onClick={handleNo}
      />
    </div>
  );
}
